import { Component, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { ToasterService } from "../../../../common/services/toaster.service";
import { ModalController } from "@ionic/angular";
import { WebOrderApprovals } from "../../models/web-order-approvals.model";
import { WebOrderService } from "../../services/web-order.service";
import { EmailService } from '../../../../../app/common/services/email.service';

@Component({
  selector: "app-email-modal",
  templateUrl: "email-modal.component.html",
  styleUrls: ["./email-modal.component.scss"],
})
export class EmailModalComponent implements OnInit {
  @Input() to: string = '';
  @Input() subject: string = '';
  body: string = '';
  cancelReason: string;
  loading:boolean=false;
  constructor(
    private router: Router,
    private toasterService: ToasterService,
    private modalController: ModalController,
    private webOrderService: WebOrderService,
    private emailService: EmailService,
  ) {}

  ngOnInit(): void {
    this.loading=true;
  }

  closeModal() {
    this.modalController.dismiss();
  }
openOutlook(){
    this.loading=false;
   if (!this.to || !this.subject || !this.body ) {
     this.toasterService.presentToast('danger', '', 'To, Subject and Body are required..', 3000);
     this.loading=true;
      return;
    }

    const mailtoLink = `mailto:${this.to}?subject=${encodeURIComponent(this.subject)}&body=${encodeURIComponent(this.body)}`;
    window.location.href = mailtoLink;
      this.loading=true;
}

async sendEmail(){
  this.loading=false;
  if (!this.to || !this.subject || !this.body ) {
     this.toasterService.presentToast('danger', '', 'To, Subject and Body are required..', 3000);
     this.loading=true;
      return;
    }
   const status = await this.emailService.sendEmail(this.body,this.subject,this.to);

      if (status) {
        this.toasterService.presentToast('primary', '', 'Email sent successfully.', 2000);
         this.modalController.dismiss();
      } else {
        this.toasterService.presentToast('danger', 'Please try again.', 'Something went wrong.', 2000);
      }
    this.loading=true;
 }
}
